import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DialogModel} from '@shared/models/dialog.model';
import {SnackBarService} from '@core/services/snack-bar.service';
import {takeUntil} from 'rxjs/operators';
import {FirmApiService} from '../../services/firm-service';
import {Subject} from 'rxjs';

@Component({
    standalone: false,
    selector: 'particle-add-user-dialog',
  templateUrl: './add-user-dialog.component.html',
  styleUrls: ['./add-user-dialog.component.scss']
})
export class AddUserDialogComponent implements OnInit, IDialogView, OnDestroy {
  inputForm: FormGroup;
  data: DialogModel;
  unsubscribe$: Subject<void> = new Subject<void>();
  subAccountPackages = [];

  constructor(private formBuilder: FormBuilder,
              private firmService: FirmApiService,
              private snackBarService: SnackBarService) {

  }

  ngOnInit() {
    this.inputForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      title: [''],
      email: ['', Validators.required],
      phone: [''],
      packages: [[]],
      message: ['', Validators.required]
    });

    this.firmService.getSubAccountPackages().pipe(takeUntil(this.unsubscribe$)).subscribe(state => {
      if (state && state.length > 0) {
        this.subAccountPackages = state;
        this.inputForm.controls['packages'].setValidators([Validators.required]);
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onOkClicked(): boolean {
    const firstName = this.inputForm.controls['firstName'].value;
    const lastName = this.inputForm.controls['lastName'].value;
    const title = this.inputForm.controls['title'].value;
    const phone = this.inputForm.controls['phone'].value;
    const email = this.inputForm.controls['email'].value;
    const packages = this.inputForm.controls['packages'].value;
    const message = this.inputForm.controls['message'].value;

    if (!this.inputForm.valid) {
      this.snackBarService.showError('Please fill up necessary fields.');
      return false;
    }

    this.data.input.firstName = firstName;
    this.data.input.lastName = lastName;
    this.data.input.title = title;
    this.data.input.email = email;
    this.data.input.phone = phone;
    this.data.input.packages = packages;
    this.data.input.message = message;
    return true;
  }
}
